import React, { useEffect, useState } from 'react'
import { LinkButton } from '@zera-admin/button'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Lozenge from '@zera-admin/lozenge'
import Page, { PageHeader } from '@zera-admin/page'
import Table from '@zera-admin/table'

import Pager from 'components/pager'
import MainLayout from 'layouts/main'
import { GenderTypeEnum } from 'services/http/dataset'
import genderDataSetsService, {
  GenderDataSet,
  GenderDataSetResponse,
} from 'services/http/dataset/gender-data-set'

import { GenderDataSetListProps } from './types'

const GenderDataSetList: React.FunctionComponent<
  GenderDataSetListProps
> = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [genderDataSet, setGenderDataSet] = useState<GenderDataSetResponse>()

  useEffect(() => {
    getGenderDataSets()
  }, [])

  const getGenderDataSets = async () => {
    try {
      const response = await genderDataSetsService.get()

      setGenderDataSet(response.data)
      setIsLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const renderPageHeader = () => {
    const actions = (
      <LinkButton appearance="primary" href="/gender-data-set/create">
        Cinsiyet veri seti oluştur
      </LinkButton>
    )

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Cinsiyet veri setleri" />
      </Breadcrumb>
    )

    const bottomBar = (
      <p>
        Tüm cinsiyet veri setlerini görüntüleyebilir, yeni oluşturabilir,
        varolanları düzenleyebilirsiniz.
      </p>
    )

    return (
      <PageHeader
        actions={actions}
        bottomBar={bottomBar}
        breadcrumbs={breadcrumbs}
      >
        Cinsiyet veri setleri
      </PageHeader>
    )
  }

  const renderPageTable = () => {
    const columns = [
      {
        name: 'text',
        text: 'Cinsiyet veri seti metni',
      },
      {
        name: 'sourceName',
        text: 'Kaynak',
      },
      {
        name: 'trainingGroupName',
        text: 'Eğitim grubu',
      },
      {
        name: 'genderType',
        text: 'Cinsiyet',
        render: (props: GenderDataSet) => {
          if (props.genderType === GenderTypeEnum.Female) {
            return <Lozenge appearance="info">Erkek</Lozenge>
          } else if (props.genderType === GenderTypeEnum.Male) {
            return <Lozenge appearance="error">Kadın</Lozenge>
          } else {
            return <Lozenge appearance="default">Belirtilmemiş</Lozenge>
          }
        },
      },
      {
        name: 'createdDate',
        text: 'Oluşturulma tarihi',
      },
      {
        name: 'operation',
        text: 'İşlemler ',
        width: '100px',
        render: (item: GenderDataSet) => (
          <LinkButton
            appearance="subtle-link"
            href={`/gender-data-set/update/${item.id}`}
          >
            Görüntüle
          </LinkButton>
        ),
      },
    ]

    if (genderDataSet) {
      return (
        <React.Fragment>
          <Table
            columns={columns as any}
            rows={genderDataSet.list}
            isLoading={isLoading}
            helperMessage="Aradığınız kriterlere uygun bir veri bulunamadı"
          />
          <Pager pages={genderDataSet.pageCount} />
        </React.Fragment>
      )
    }

    return null
  }

  return (
    <MainLayout>
      <Page>
        {renderPageHeader()}
        {renderPageTable()}
      </Page>
    </MainLayout>
  )
}

export default GenderDataSetList
